import styled from 'styled-components';
import { DEVICES } from '_constants';
import { UiColors } from 'assets/styles/old/global';

/* New-design row action: a forest icon button, matching the inline icon buttons in the campaign
   assignment cells. Drawn in currentColor, so the colour is set here and nowhere else. */
export const IconButton = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 6px;
  color: ${UiColors.forestColor};
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover {
    background: ${UiColors.headerTableGray};
  }

  svg {
    width: 17px;
    height: 17px;
  }
`;

export const Title = styled.div`
  margin: 0 0 0 8px;
  display: none;
`;

export const CellWrapper = styled.div`
  border: none;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  background: transparent;
  cursor: pointer;

  @media ${DEVICES.tableView} {
    width: max-content;
    margin: 0 0 0 auto;

    ${Title} {
      display: block;
    }
  }
`;
